import { createContext, Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from 'react'
import breakpoints from '../../assets/scss/breakpoints.module.scss'

export interface BreakpointsContextProps {
  breakpoints: Record<string, string>
  isLargeUp?: boolean
  isMediumUp?: boolean
  isXLargeUp?: boolean
  setIsLargeUp: Dispatch<SetStateAction<boolean | undefined>>
  setIsMediumUp: Dispatch<SetStateAction<boolean | undefined>>
  setIsXLargeUp: Dispatch<SetStateAction<boolean | undefined>>
}

export const BreakpointsContext = createContext({} as BreakpointsContextProps)

export const BreakpointsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isLargeUp, setIsLargeUp] = useState<boolean>()
  const [isMediumUp, setIsMediumUp] = useState<boolean>()
  const [isXLargeUp, setIsXLargeUp] = useState<boolean>()

  const breakpointRecords: Record<string, string> = {}
  Object.entries(breakpoints).map(([name, mediaQuery]) => {
    const match = mediaQuery.match(/[0-9]+/)

    if (match && match[0]) {
      breakpointRecords[name] = match[0]
    }
  })

  const handleResize = () => {
    setIsLargeUp(window.matchMedia(breakpoints['large-up']).matches)
    setIsMediumUp(window.matchMedia(breakpoints['medium-up']).matches)
    setIsXLargeUp(window.matchMedia(breakpoints['xlarge-up']).matches)
  }

  useEffect(() => {
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <BreakpointsContext.Provider
      value={{
        breakpoints: breakpointRecords,
        isLargeUp,
        isMediumUp,
        isXLargeUp,
        setIsLargeUp,
        setIsMediumUp,
        setIsXLargeUp,
      }}>
      {children}
    </BreakpointsContext.Provider>
  )
}
